import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getClientesId, putClient } from "../../redux/actions/actionClient";

export default function ClientModify() {
  // const initialForm = {
  //     name: "",
  //     lastName:"",

  // }

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const cliente = useSelector((state) => state.clientes.clientesDetail);

  useEffect(() => {
    dispatch(getClientesId(id));
  }, [dispatch, id]);

  const [form, setForm] = useState({
    name: cliente.name,
    lastName: cliente.lastName,
    nameCompany: cliente.nameCompany,
    address: cliente.address,
    city: cliente.city,
    telephoneNumber: cliente.telephoneNumber,
    contactName: cliente.contactName,
    email: cliente.email,
    notes: cliente.notes,
  });

  console.log(form);

  const handleChange = (e) => {
    const { value } = e.target;
    setForm({
      ...form,
      [e.target.name]: value,
    });
  };

  const handleRestaurar = () => {
    setForm({
        name: cliente.name,
        lastName: cliente.lastName,
        nameCompany: cliente.nameCompany,
        address: cliente.address,
        city: cliente.city,
        telephoneNumber: cliente.telephoneNumber,
        contactName: cliente.contactName,
        email: cliente.email,
        notes: cliente.notes,
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(putClient(id, form))
    navigate(`/clientes/${id}`)
  }




  return (
    <div className="min-w-full bg-gray-900">
      <div className="container m-8 text-orange-500 text-[10pt] font-bold">
        <div className="text-xl underline">Modificacion Cliente</div>
        <div className="mt-6">
          <div>
            <p>Cliente N°: {cliente.idClient}</p>
          </div>
          <div className="flex w-3/3 py-4 border-b-2 border-slate-500">
            <div className="w-1/3">
              <label className="w-1/3 pr-2">Empresa:</label>
              <input
                className="bg-slate-700 rounded w-1/2 pl-2"
                type="text"
                name="nameCompany"
                placeholder=""
                onChange={handleChange}
                value={form.nameCompany}
              />
            </div>
            <div className="w-1/3">
              <label className="w-1/3 pr-2">Nombre:</label>
              <input
                className="bg-slate-700 rounded w-1/2 pl-2"
                type="text"
                name="name"
                placeholder=""
                onChange={handleChange}
                value={form.name}
              />
            </div>
            <div className="w-1/3">
              <label className="w-1/3 pr-2">Apellido:</label>
              <input
                className="bg-slate-700 rounded w-1/2 pl-2"
                type="text"
                name="lastname"
                placeholder=""
                onChange={handleChange}
                value={form.lastName}
              />
            </div>
          </div>
          <div className="flex w-3/3 py-4 border-b-2 border-slate-500">
            <div className="w-1/3">
              <label className="w-1/3 pr-2">Domicilio:</label>
              <input
                className="bg-slate-700 rounded w-1/2 pl-2"
                type="text"
                name="address"
                placeholder=""
                onChange={handleChange}
                value={form.address}
              />
            </div>
            <div className="w-1/3">
              <label className="w-1/3 pr-2">Ciudad:</label>
              <input
                className="bg-slate-700 rounded w-1/2 pl-2"
                type="text"
                name="city"
                placeholder=""
                onChange={handleChange}
                value={form.city}
              />
            </div>
            <div className="w-1/3">
              <label className="w-1/3 pr-2">Telefonos:</label>
              <input
                className="bg-slate-700 rounded w-1/2 pl-2"
                type="text"
                name="telephoneNumber"
                placeholder=""
                onChange={handleChange}
                value={form.telephoneNumber}
              />
            </div>
          </div>
          <div className="flex w-3/3 py-4 border-b-2 border-slate-500">
            <div className="w-1/3">
              <label className="w-1/3 pr-2">Contacto:</label>
              <input
                className="bg-slate-700 rounded w-1/2 pl-2"
                type="text"
                name="contactName"
                placeholder=""
                onChange={handleChange}
                value={form.contactName}
              />
            </div>
            <div className="w-1/3">
              <label className="w-1/3 pr-2">Email:</label>
              <input
                className="bg-slate-700 rounded w-1/2 pl-2"
                type="email"
                name="email"
                placeholder=""
                onChange={handleChange}
                value={form.email}
              />
            </div>
            <div className="w-1/3">
              <label className="w-1/3 pr-2">Notas:</label>
              <input
                className="bg-slate-700 rounded w-1/2 pl-2"
                type="text"
                name="notes"
                placeholder=""
                onChange={handleChange}
                value={form.notes}
              />
            </div>
          </div>
          <div className="flex w-2/3 justify-between">
          <button
          className="mt-12 p-4 rounded bg-sky-500 text-white"
          onClick={handleSubmit}
        >
          Guardar
        </button> 
        <button
          className="mt-12 p-4 rounded bg-red-500 text-white"
          onClick={handleRestaurar}
        >
          Restaurar
        </button>
          </div>
        </div>
      </div>
    </div>
  );
}
